module.exports = __webpack_public_path__ + "img/53bg.b939bbfc.png";